"use strict";

var React = require('react'),
    DocumentTitle = require('react-document-title'),
    ToolboxSidebar = require('./Sidebar'),
    Header = require('./Header'),
    Footer = require('./Footer'),
    Documents = require('../project/ProjectDocuments');

var ToolboxDocuments = React.createClass({displayName: "ToolboxDocuments",
    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            emptyMessage = 'There are no documents available. Use the form to the left to send the builder a quick message to request documents.',
            description = (
                React.createElement("h5", null, "Click on the icon to download a document. Use the “Send Builder a Quick Message” on the left side of this page to request specific documents.")
            ),
            title = props.title + ' - Documents';

        return (
            React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: title}), 
                React.createElement(Header, {project: props.project, builder: props.builder}), 
                React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        React.createElement(ToolboxSidebar, {project: props.project, showContactForm: true}), 
                        React.createElement("div", {className: "col-sm-9"}, 
                            React.createElement(Documents, {model: props.project, readOnly: true, emptyMessage: emptyMessage, description: description})
                        ), 
                        React.createElement(Footer, {trackerId: "agent-toolbox-documents"})
                    )
                )
            )
        );
    }
});

module.exports = ToolboxDocuments;
